import { Overlay } from "ol";

let popup;

export function initPopup(map) {
  popup = new Overlay({
    element: document.getElementById("popup"),
    positioning: "bottom-center", // Position the popup relative to its anchor point
    stopEvent: true, // Stop map events (like click) when interacting with the popup
    offset: [0, 13], // Offset the popup to align the pointer with the clicked coordinate
  });

  map.addOverlay(popup);

  document.getElementById("popup-closer").onclick = function () {
    // Hide the popup by setting its position to undefined
    popup.setPosition(undefined);
    // Prevent the default action of the click event
    return false;
  };

  // Listen for clicks on the map and display the popup if a feature is clicked
  map.on("click", (evt) => clickHandler(evt, map));
}

function clickHandler(evt, map) {
  // Define margins to determine if the clicked point is too close to the map edges
  const margins = {
    left: 75,
    right: 75,
    top: 75,
    bottom: 10,
  };

  // Define the number of pixels to pan the map if the clicked point is too close to an edge
  const panPixels = {
    left: 60,
    right: 60,
    top: 60,
    bottom: 10,
  };

  // Get the feature at the clicked position
  const feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
    return feature;
  });

  // Check if a feature was clicked
  if (feature) {
    // Display the popup if the feature has more than the geometry property
    if (Object.keys(feature.getProperties()).length > 1) {
      displayPopup(feature);
      setPopupPosition(evt.coordinate);
    }

    // Check if the popup is too close to the map edges and pan the map if necessary
    checkDistanceFromEdges(evt, map, margins, panPixels);
  } else {
    // If no feature is clicked, hide the popup
    popup.setPosition(undefined);
  }
}

export function displayPopup(feature) {
  // Set popup content based on feature properties, as text so values from the search API can't inject HTML
  const { type, name } = feature.getProperties();
  const content = document.getElementById("popup-content");
  content.replaceChildren();

  if (type !== undefined) {
    const typeElement = document.createElement("strong");
    typeElement.textContent = type;
    content.append(typeElement, document.createElement("br"));
  }
  if (name !== undefined) {
    content.append(String(name));
  }
}

export function setPopupPosition(coordinates) {
  popup.setPosition(coordinates);
}

/**
 * Checks if a clicked point on the map is too close to the edges and pans the map if necessary.
 * @param {Object} evt - The event object containing details about the clicked point.
 * @param {Object} map - The map instance.
 * @param {Object} margins - The margins for each edge (left, right, top, bottom).
 * @param {Object} panPixels - The number of pixels to pan for each edge if the point is too close.
 * @returns {Object} - An object indicating which edges the point is too close to.
 */
function checkDistanceFromEdges(evt, map, margins, panPixels) {
  // Get the pixel coordinates of the clicked point
  const pixel = map.getPixelFromCoordinate(evt.coordinate);
  // Get the size of the map (width, height in pixels)
  const mapSize = map.getSize();

  // Calculate the distance of the clicked point from each edge
  const fromLeft = pixel[0];
  const fromRight = mapSize[0] - pixel[0];
  const fromTop = pixel[1];
  const fromBottom = mapSize[1] - pixel[1];

  // Determine if the clicked point is too close to any of the edges
  const results = {
    tooCloseToLeft: fromLeft < margins.left,
    tooCloseToRight: fromRight < margins.right,
    tooCloseToTop: fromTop < margins.top,
    tooCloseToBottom: fromBottom < margins.bottom,
  };

  // Initialize the number of pixels to pan in each direction
  const panByPixels = {
    x: 0,
    y: 0,
  };

  // Set the pan values based on which edges the point is too close to
  if (results.tooCloseToLeft) {
    panByPixels.x = -panPixels.left;
  } else if (results.tooCloseToRight) {
    panByPixels.x = panPixels.right;
  }

  if (results.tooCloseToTop) {
    panByPixels.y = -panPixels.top;
  } else if (results.tooCloseToBottom) {
    panByPixels.y = panPixels.bottom;
  }

  // If we need to pan in either direction, adjust the map's center
  if (panByPixels.x !== 0 || panByPixels.y !== 0) {
    const view = map.getView();
    const currentCenterPixel = map.getPixelFromCoordinate(view.getCenter());
    const newCenterPixel = [currentCenterPixel[0] + panByPixels.x, currentCenterPixel[1] + panByPixels.y];
    const newCenterCoord = map.getCoordinateFromPixel(newCenterPixel);

    // Animate the map to the new center
    view.animate({
      center: newCenterCoord,
      duration: 500,
    });
  }

  return results;
}
